export const PriorToTypes = {
  DOC: 'Doc',
  FUNDING: 'Funding',
  WIRE: 'Wire',
  INVESTOR: 'Investor',
  APPROVAL_CLOSING: 'ApprovalClosing',
};

const PriorToCustomDisplayNames = {
  [PriorToTypes.APPROVAL_CLOSING]: 'Approval - Closing',
};

export const PRIOR_TO_ORDER = {
  [PriorToTypes.DOC]: 1,
  [PriorToTypes.FUNDING]: 2,
  [PriorToTypes.WIRE]: 3,
  [PriorToTypes.INVESTOR]: 4,
  [PriorToTypes.APPROVAL_CLOSING]: 5,
};

export const ConditionKey = {
  NUMBER: 'number',
  MESSAGE: 'message',
  INTERNAL_TEXT: 'internalText',
  PRIOR_TO_TYPE: 'conditionPriorToType',
  SIGNED_OFF: 'signedOff',
  SIGNED_OFF_BY: 'signedOffBy',
  CREATED_DATE: 'createdDate',
  CREATED_BY: 'createdBy',
  LAST_MODIFIED: 'lastModified',
  REJECTED_DATE: 'rejectedDate',
  ACTIONS: 'actions',
  COLLAPSE: 'collapse',
};

export const formatPriorToDisplayName = priorToValue =>
  PriorToCustomDisplayNames[priorToValue] || priorToValue;
